import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, MessageSquare } from 'lucide-react';

const Box = ({
  icon,
  title,
  description,
  actions,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  actions: { label: string; to: string }[];
}) => {
  return (
    <div className="w-full md:w-96 bg-white border border-neutral-200 rounded-card shadow-card hover:shadow-card-hover transition-shadow p-6">
      <div className="flex flex-row items-center mb-4">
        <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
          {icon}
        </div>
        <h2 className="text-heading-md font-bold ml-3 text-neutral-900">{title}</h2>
      </div>

      <hr className="mb-4 border-neutral-200" />

      <p className="text-body-sm text-neutral-600 mb-4 leading-relaxed">{description}</p>

      <div className="flex flex-col space-y-2">
        {actions.map((action, i) => (
          <Link
            key={i}
            className="bg-primary-600 hover:bg-primary-700 px-4 py-2.5 rounded-button shadow-button transition-colors text-center"
            to={action.to}
          >
            <p className="text-white text-body-sm font-medium">{action.label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

const HomePage = () => {
  return (
    <div className="px-page-sm py-6 lg:px-page lg:py-8 w-full">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-heading-lg text-neutral-900 mb-8">Tableau de bord</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Box
            icon={<Building2 size={24} className="text-primary-600" />}
            title="Mon parc"
            description="Visualisez votre parc et accédez simplement aux détails de chacune de vos résidences"
            actions={[{ label: 'Voir mes résidences', to: '/properties' }]}
          />
          <Box
            icon={<MessageSquare size={24} className="text-primary-600" />}
            title="Communication"
            description="Retrouvez ici les messages envoyés aux résidents et programmez l'envoi de nouveaux messages"
            actions={[
              { label: 'Nouveau message', to: '/messages/new' },
              { label: 'Voir mes messages', to: '/messages' },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
